export default __webpack_public_path__ + "static/media/start.caaeb97c.svg";